export const SERVICE_GET_LIST = 'SERVICE_GET_LIST';
